import { useCallback, useEffect, useState } from "react";
import type { Coffee } from "../types";
import { api } from "../lib/api";

export function useCoffees(params: Record<string, string> = {}) {
  const [data, setData] = useState<Coffee[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const key = JSON.stringify(params);

  const refresh = useCallback(() => {
    setError(null);
    api.list(params).then(setData).catch((e: Error) => setError(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh };
}

export function useCoffee(id: number | null) {
  const [data, setData] = useState<Coffee | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    if (id === null) return;
    setError(null);
    api.get(id).then(setData).catch((e: Error) => setError(e.message));
  }, [id]);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh, setData };
}
